"use client";
import { createContext, useContext } from "react";
import type { TenantBrand } from "@/lib/tenant-brand";

/**
 * Brandul tenantului (din rodesk.io) livrat clientului. Root layout-ul îl rezolvă pe server
 * și îl pune aici; AppShell îl citește ca să afișeze logo-ul + culoarea firmei în aplicație.
 * `null` = firmă fără brand .io → aplicația arată brandul implicit Rodesk.ai.
 */
const BrandContext = createContext<TenantBrand | null>(null);

export function BrandProvider({ brand, children }: { brand: TenantBrand | null; children: React.ReactNode }) {
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useTenantBrand(): TenantBrand | null {
  return useContext(BrandContext);
}
